import {
  Landmark, PiggyBank, FileBadge, HandCoins, CreditCard, BookOpenCheck, Wallet,
  FolderOpen, BellRing, ShieldCheck, BarChart3, Smartphone, Cloud, Code2, Server,
  Blocks, LifeBuoy, Globe, Briefcase, PhoneCall, MessageSquare, Braces, Database,
  Lightbulb, BadgeCheck, Handshake, Building2, Banknote, Network, Workflow, Users,
  Coins, Zap, Activity, Video, Ticket, House,
} from "lucide-react";

export const NAV_LINKS = [
  { label: "Inicio", to: "/" },
  { label: "Soluciones", to: "/#soluciones", hash: "soluciones" },
  { label: "CoopSys", to: "/coopsys" },
  { label: "Servicios", to: "/servicios" },
  { label: "Empresa", to: "/empresa" },
  { label: "Clientes", to: "/clientes" },
  { label: "Recursos", to: "/recursos" },
  { label: "Contacto", to: "/contacto" },
];

export const TRUST_ITEMS = [
  { icon: Cloud, label: "Cloud" },
  { icon: ShieldCheck, label: "Security" },
  { icon: Database, label: "PostgreSQL" },
  { icon: Server, label: "Node.js" },
  { icon: Code2, label: "React" },
  { icon: Braces, label: "APIs" },
  { icon: Workflow, label: "Automatización" },
  { icon: BarChart3, label: "Data" },
];

export const QUE_HACEMOS = [
  {
    icon: Building2,
    title: "Software Empresarial",
    desc: "Sistemas diseñados para administrar y automatizar operaciones empresariales.",
  },
  {
    icon: Landmark,
    title: "FinTech & Core Banking",
    desc: "Plataformas especializadas para cooperativas e instituciones financieras.",
  },
  {
    icon: Cloud,
    title: "Cloud & Infraestructura",
    desc: "Arquitecturas modernas, escalables y orientadas a alta disponibilidad.",
  },
  {
    icon: Workflow,
    title: "Integraciones & Automatización",
    desc: "Conectamos sistemas, servicios y procesos para reducir tareas manuales.",
  },
];

export const MODULOS = [
  { icon: PiggyBank, title: "Ahorros", desc: "Gestión de cuentas, movimientos, intereses y operaciones." },
  { icon: Users, title: "Aportaciones", desc: "Control del capital social y aportaciones de los socios." },
  { icon: FileBadge, title: "Certificados", desc: "Administración de certificados financieros y cálculo de intereses." },
  { icon: HandCoins, title: "Préstamos", desc: "Gestión integral de cartera, cuotas, intereses y cobros." },
  { icon: CreditCard, title: "Líneas de Crédito", desc: "Administración de líneas y desembolsos." },
  { icon: BookOpenCheck, title: "Contabilidad", desc: "Contabilidad integrada con las operaciones financieras." },
  { icon: Wallet, title: "Caja", desc: "Control de ingresos, egresos y operaciones de caja." },
  { icon: FolderOpen, title: "Documentos", desc: "Gestión y almacenamiento de documentos digitales." },
  { icon: BellRing, title: "Notificaciones", desc: "Comunicación automatizada mediante email, SMS y WhatsApp." },
  { icon: ShieldCheck, title: "AML / Cumplimiento", desc: "Herramientas para controles de prevención de lavado de activos." },
  { icon: BarChart3, title: "Reportería", desc: "Dashboards e información para la toma de decisiones." },
  { icon: Smartphone, title: "Banca Digital", desc: "Integración con canales digitales e Internet Banking." },
];

export const HUB_NODES = [
  { icon: Users, label: "Socios" },
  { icon: PiggyBank, label: "Ahorros" },
  { icon: HandCoins, label: "Préstamos" },
  { icon: BookOpenCheck, label: "Contabilidad" },
  { icon: Wallet, label: "Caja" },
  { icon: FolderOpen, label: "Documentos" },
  { icon: BellRing, label: "Notificaciones" },
  { icon: Smartphone, label: "Banca Digital" },
  { icon: BarChart3, label: "Reportes" },
];

export const CLOUD_HIGHLIGHTS = [
  { icon: Globe, title: "Acceso remoto", desc: "Tu información disponible desde cualquier lugar." },
  { icon: Activity, title: "Escalabilidad", desc: "Crece sin rediseñar tu infraestructura." },
  { icon: Database, title: "Backups", desc: "Copias de seguridad automatizadas." },
  { icon: ShieldCheck, title: "Seguridad", desc: "Protección en cada capa de la plataforma." },
  { icon: Zap, title: "Monitoreo", desc: "Vigilancia continua de la operación." },
  { icon: Server, title: "Disponibilidad", desc: "Arquitectura orientada a alta disponibilidad." },
];

export const SECURITY_LAYERS = [
  { name: "Aplicación", items: ["Autenticación", "Roles", "Permisos"] },
  { name: "API", items: ["Tokens", "Control de acceso", "Validaciones"] },
  { name: "Infraestructura", items: ["Firewall", "SSL/TLS", "Monitoreo"] },
  { name: "Datos", items: ["PostgreSQL", "Backups", "Auditoría"] },
];

export const SERVICIOS = [
  { icon: Code2, title: "Desarrollo de Software", desc: "Aplicaciones web, sistemas empresariales y plataformas personalizadas." },
  { icon: Smartphone, title: "Aplicaciones Móviles", desc: "Desarrollo de aplicaciones Android e iOS." },
  { icon: Server, title: "Infraestructura", desc: "Diseño, configuración y administración de infraestructura tecnológica." },
  { icon: ShieldCheck, title: "Ciberseguridad", desc: "Protección, monitoreo y buenas prácticas de seguridad informática." },
  { icon: Cloud, title: "Cloud", desc: "Arquitectura, migración y administración de servicios cloud." },
  { icon: Blocks, title: "Integraciones", desc: "APIs, servicios externos, automatizaciones e integración de plataformas." },
  { icon: LifeBuoy, title: "Soporte Técnico", desc: "Acompañamiento y soporte especializado." },
  { icon: PhoneCall, title: "Centrales Telefónicas", desc: "Instalación y configuración de central telefónica y telefonía IP empresarial." },
  { icon: Network, title: "Cable Estructurado / Instalación de Redes", desc: "Diseño e instalación de cableado estructurado y redes de datos." },
  { icon: Video, title: "Sistemas de Seguridad y CCTV", desc: "Instalación de sistemas de seguridad y videovigilancia CCTV." },
  { icon: Ticket, title: "Sistema de Turnos y Kiosco", desc: "Kioscos de autoservicio y gestión de turnos para atención al público." },
  { icon: House, title: "Smart Home - Domótica", desc: "Automatización de espacios: control inteligente de iluminación, clima y seguridad." },
];

export const ECOSISTEMA = [
  { icon: Landmark, title: "CoopSys CoreBank", desc: "Core Banking para cooperativas.", featured: true },
  { icon: Globe, title: "CoopSys Internet Banking", desc: "Servicios financieros digitales para socios." },
  { icon: Briefcase, title: "Soluciones Empresariales", desc: "Software de administración y automatización." },
  { icon: Zap, title: "SITECO", desc: "Soluciones de automatización y sistemas de pago." },
  { icon: PhoneCall, title: "Comunicaciones", desc: "Soluciones de telefonía IP y comunicaciones empresariales." },
];

export const INTEGRACIONES = [
  { icon: Banknote, title: "Financiero", items: ["Pagos", "Transferencias", "Servicios financieros"] },
  { icon: MessageSquare, title: "Comunicación", items: ["Email", "SMS", "WhatsApp"] },
  { icon: Database, title: "Gobierno / Datos", items: ["DGII", "Servicios de consulta", "Reportes"] },
  { icon: ShieldCheck, title: "Crédito", items: ["Burós", "Información crediticia"] },
  { icon: Braces, title: "API", items: ["REST API", "Webhooks", "Integraciones personalizadas"] },
];

export const EMPRESA_VALORES = [
  { icon: Lightbulb, title: "Innovación", desc: "Buscamos constantemente nuevas tecnologías y mejores formas de resolver problemas." },
  { icon: BadgeCheck, title: "Calidad", desc: "Priorizamos soluciones estables, mantenibles y fáciles de utilizar." },
  { icon: Handshake, title: "Acompañamiento", desc: "Trabajamos junto a nuestros clientes durante la implementación y evolución de sus soluciones." },
];

export const SECTOR_ITEMS = [
  "Socios", "Ahorros", "Aportaciones", "Préstamos", "Certificados",
  "Caja", "Contabilidad", "Cobros", "Reportes", "Banca digital",
];

export const CASOS_DE_USO = [
  { icon: Landmark, title: "Cooperativas", desc: "Gestión financiera integral." },
  { icon: Building2, title: "Empresas", desc: "Administración y automatización." },
  { icon: Banknote, title: "Instituciones financieras", desc: "Software especializado." },
  { icon: Network, title: "Operaciones con múltiples sucursales", desc: "Control centralizado." },
  { icon: Workflow, title: "Procesos automatizados", desc: "Reducción de tareas manuales." },
];

export const PROCESO = [
  { num: "01", title: "Descubrimiento", desc: "Entendemos el problema." },
  { num: "02", title: "Diseño", desc: "Diseñamos la solución." },
  { num: "03", title: "Desarrollo", desc: "Construimos la plataforma." },
  { num: "04", title: "Implementación", desc: "Integramos la solución." },
  { num: "05", title: "Soporte", desc: "Acompañamos al cliente." },
  { num: "06", title: "Evolución", desc: "Mejoramos continuamente." },
];

export const BLOG_CATEGORIES = [
  "Tecnología", "Cooperativas", "Cloud", "Seguridad", "Software", "Automatización", "Noticias DASOFT",
];

export const ARTICULOS = [
  {
    slug: "automatizacion-cooperativas",
    category: "Automatización",
    title: "Automatización de procesos en cooperativas: por dónde empezar",
    excerpt: "Identificar tareas repetitivas, ordenar los datos y conectar los sistemas: tres pasos concretos para comenzar a automatizar sin complicar la operación.",
    date: "2026-01-15",
    readTime: "5 min",
    content: [
      "En muchas cooperativas, una parte importante del equipo dedica horas cada semana a tareas repetitivas: registrar movimientos en varios sistemas, calcular cuotas, preparar reportes o notificar a los socios. Ninguna de estas tareas es compleja por sí sola, pero juntas consumen tiempo que podría dedicarse a atender mejor a los socios.",
      "El primer paso no es tecnológico, es organizacional: identificar qué procesos se repiten con frecuencia, cuáles generan más errores al hacerse a mano y cuáles dependen de información que ya existe en otro lugar. Ese inventario simple define dónde la automatización tendrá mayor impacto.",
      "El segundo paso es ordenar los datos. Automatizar un proceso que depende de información dispersa en hojas de cálculo o en sistemas que no conversan entre sí solo traslada el problema. Un core banking como CoopSys centraliza socios, ahorros, préstamos y contabilidad en una sola fuente, y esa centralización es la que hace posible automatizar con confianza.",
      "El tercer paso es integrar en lugar de duplicar. Antes de crear un proceso paralelo, conviene revisar qué ofrece la plataforma: notificaciones automáticas por email, SMS o WhatsApp, reportería consolidada y alertas de cumplimiento pueden cubrir buena parte de las necesidades sin desarrollo adicional.",
      "Finalmente, medir. Un proceso automatizado se puede afinar: reducir tiempos de respuesta, disminuir reprocesos y liberar al equipo para actividades de mayor valor. La automatización no es un proyecto de una vez, es una práctica continua de mejora.",
    ],
  },
  {
    slug: "cloud-sector-financiero",
    category: "Cloud",
    title: "Cloud para el sector financiero: qué considerar antes de migrar",
    excerpt: "Disponibilidad, seguridad, continuidad operativa y acompañamiento: los cuatro criterios que una cooperativa debería evaluar antes de llevar su operación a la nube.",
    date: "2026-02-02",
    readTime: "6 min",
    content: [
      "Llevar la operación financiera a la nube dejó de ser una apuesta arriesgada para convertirse en una decisión de negocio: permite acceder a la información desde cualquier lugar, escalar según la demanda y reducir la dependencia de infraestructura local.",
      "El primer criterio es la disponibilidad. Una cooperativa no puede darse el lujo de estar fuera de línea durante horas de operación. Es importante entender cómo está diseñada la arquitectura del proveedor: respaldo de servidores, monitoreo permanente y planes de contingencia claros.",
      "El segundo es la seguridad. Más allá de las certificaciones, vale preguntar cómo se protegen los datos en tránsito y en reposo, cómo se gestionan los accesos y roles, y qué mecanismos de auditoría existen para saber quién hizo qué y cuándo.",
      "El tercero es la continuidad operativa. Las copias de seguridad deben ser automáticas, probadas y accesibles. Un backup que nunca se ha restaurado no es un backup: es una expectativa.",
      "El cuarto es el acompañamiento. La migración no termina con el traslado de la información; termina cuando el equipo de la cooperativa opera con confianza en la nueva plataforma. Contar con un socio tecnológico que participe antes, durante y después marca la diferencia.",
    ],
  },
  {
    slug: "core-banking-cooperativa-moderna",
    category: "Cooperativas",
    title: "Core Banking: el corazón digital de una cooperativa moderna",
    excerpt: "Qué es un core banking, por qué la contabilidad integrada y la banca digital cambian la forma de operar, y qué debería buscar una cooperativa al evaluar una plataforma.",
    date: "2026-02-20",
    readTime: "5 min",
    content: [
      "Un core banking es el sistema central donde ocurre todo: los ahorros de los socios, los préstamos otorgados, las aportaciones, la caja y la contabilidad. Cuando este núcleo está integrado, cada operación se refleja al instante en los estados financieros; cuando está fragmentado, la conciliación se convierte en un trabajo manual y eterno.",
      "Para una cooperativa de ahorro, crédito y servicios múltiples, el core banking no es un software más: es la infraestructura sobre la que se construye la relación con cada socio. De su calidad dependen los tiempos de respuesta, la exactitud de los intereses y la capacidad de tomar decisiones con información oportuna.",
      "Al evaluar una plataforma conviene revisar tres cosas. Primero, que los módulos conversen entre sí: un desembolso debe generar su plan de cuotas, sus asientos contables y sus notificaciones sin doble digitación. Segundo, que la reportería sea útil para la dirección: dashboards de cartera, ahorros y morosidad, no solo listas de transacciones. Tercero, que el camino hacia la banca digital esté previsto, porque los socios esperan cada vez más consultar y operar desde sus dispositivos.",
      "La tecnología especializada en el sector cooperativo entiende estos flujos de forma nativa. Un core diseñado alrededor de las necesidades de las cooperativas reduce la curva de implementación y permite que el equipo se enfoque en lo que realmente distingue a cada institución: sus socios.",
    ],
  },
];

export const SERVICIO_OPTIONS = [
  "CoopSys CoreBank", "Desarrollo de software", "Cloud", "Infraestructura",
  "Seguridad", "Integraciones", "Soporte", "Otro",
];

export const CONTACT_INFO = {
  email: "info@dasoft.com.do",
  site: "www.dasoft.com.do",
  location: "Santiago, República Dominicana",
  phone: '1-849-937-0818'
};

export const INFRA_SERVICIOS = [
  {
    icon: PhoneCall,
    title: "Centrales Telefónicas",
    desc: "Instalación y configuración de central telefónica y telefonía IP para la comunicación de tu organización.",
    img: "https://images.unsplash.com/photo-1766066014237-00645c74e9c6?crop=entropy&cs=srgb&fm=jpg&q=80&w=900&auto=format&fit=crop",
  },
  {
    icon: Network,
    title: "Cable Estructurado / Instalación de Redes",
    desc: "Diseño e instalación de cableado estructurado y redes de datos, listas para crecer.",
    img: "https://images.unsplash.com/photo-1581092919535-7146ff1a590b?crop=entropy&cs=srgb&fm=jpg&q=80&w=900&auto=format&fit=crop",
  },
  {
    icon: Video,
    title: "Sistemas de Seguridad y CCTV",
    desc: "Instalación de sistemas de seguridad y videovigilancia para proteger tus instalaciones.",
    img: "https://images.pexels.com/photos/30692441/pexels-photo-30692441.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    icon: Ticket,
    title: "Sistema de Turnos y Kiosco",
    desc: "Kioscos de autoservicio y gestión de turnos para ordenar la atención al público.",
    img: "https://images.unsplash.com/photo-1715635845887-874afda292b8?crop=entropy&cs=srgb&fm=jpg&q=80&w=900&auto=format&fit=crop",
  },
  {
    icon: House,
    title: "Smart Home - Domótica",
    desc: "Automatización de espacios: control inteligente de iluminación, clima y seguridad.",
    img: "https://images.unsplash.com/photo-1608377205619-03a0b4c4e270?crop=entropy&cs=srgb&fm=jpg&q=80&w=900&auto=format&fit=crop",
  },
];

export const WHATSAPP = {
  number: "18499370818",
  message: "Hola DASOFT, me gustaría recibir más información sobre sus soluciones tecnológicas.",
};


export const PAYMENT_ACCOUNTS = [
  {
    banco: "BanReservas",
    tipo: "Cuenta Corriente",
    numero: "1202116075",
    titular: "D ANGEL SOFTWARE ELECTRONIC SRL",
    moneda: "RD$",
  },
];